import CONFIG from '../api/config';

const nr = () => (typeof window !== 'undefined' ? window.newrelic : undefined);

export const initNewRelic = () => {
    const agent = nr();
    if (!agent) return;
    agent.setCustomAttribute('environment', CONFIG.APP_ENV);
    if (process.env.REACT_APP_RELEASE_ID) {
        agent.setApplicationVersion(process.env.REACT_APP_RELEASE_ID);
    }
};

export const newRelicSetUserContext = userId => {
    const agent = nr();
    if (!agent || !userId) return;
    if (typeof agent.setUserId === 'function') agent.setUserId(String(userId));
    else agent.setCustomAttribute('userId', String(userId));
};



// WEBPACK FOOTER //
// ./src/lib/newrelicConfig.js